import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'

import { useTheme } from 'styled-components/native'

import { EssentialsIcon } from '../../atoms/icons/EssentialsIcon'
import { MessageAttachment, MessageAttachmentProps } from '../messageAttachment/MessageAttachment'

export type EssentialsLinkMessageAttachmentProps = Omit<MessageAttachmentProps, 'icon' | 'closeTooltipLabel'>

export const EssentialsLinkMessageAttachment: FunctionComponent<EssentialsLinkMessageAttachmentProps> = ({
  text,
  ...props
}) => {
  const { formatMessage } = useIntl()
  const { colors } = useTheme()

  const formatUrlSlug = (url: string): string => {
    const lastSegment = url.split('/').pop() || ''
    const segmentWithoutQuery = lastSegment.split('?')[0]
    const words = segmentWithoutQuery.split('-')
    const formattedWords = words.map((word, index) =>
      index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word,
    )
    return formattedWords.join(' ')
  }

  return (
    <MessageAttachment
      {...props}
      text={
        text
          ? formatUrlSlug(text)
          : formatMessage({
              defaultMessage: 'Wellness Library',
              description: 'Attachment to link user to wellness library',
            })
      }
      icon={<EssentialsIcon fillColor={colors.iconActive} />}
      closeTooltipLabel={formatMessage({
        defaultMessage: 'Remove Wellness library link',
        description: 'Tooltip label to remove Wellness library link',
      })}
    />
  )
}
